<ng-container *ngIf="vm$ | async as vm">

    <div class="flex-column">
        <defect-list [readonly]="$safeNavigationMigration(vm?.metadata?.readonly)" (add)="onOpenDialog(DialogType.New)" (edit)="onEdit($event)" (delete)="onDelete($event)" [defects]="$safeNavigationMigration(vm?.defects)"></defect-list>
    </div>
    <side-dialog [open]="true" *ngIf="vm?.dialog === DialogType.New || vm?.dialog === DialogType.Edit">
        <div class="dialog-title">
            {{vm?.dialog}} Defect
        </div>
        <div class="dialog-body">
            <defect-creator #defect [mode]="$safeNavigationMigration(vm?.dialog)" [defect]="$safeNavigationMigration(vm?.selectedDefect)" [defaultRaisedBy]="$safeNavigationMigration(vm?.metadata?.currentUser)" [dateFormat]="$safeNavigationMigration(vm?.metadata?.dateFormat)" [timezone]="$safeNavigationMigration(vm?.metadata?.timezone)"></defect-creator>
        </div>
        <div class="dialog-footer">
            <button type="button" (click)="onCancel(!defect?.form?.pristine)" class="btn btn-cancel">Cancel</button>
            <button type="button" (click)="onSaveDefect($safeNavigationMigration(defect?.form?.value))" [disabled]="$safeNavigationMigration(defect?.form?.invalid)" class="btn btn-success">Save</button>
        </div>
    </side-dialog>
</ng-container>